import { handleActions } from 'redux-actions';
import * as executorCardActions from '../actions/executorCard';

let initState = {
  isLoading: false,
  errorMessage: '',
};

export const executorCard = handleActions(
  {
    [executorCardActions.getExecutorById]: state => {
      return { ...state, isLoading: true };
    },
    [executorCardActions.getExecutorByIdSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        executorData: payload,
        isLoading: false,
      };
    },
    [executorCardActions.getExecutorByIdFailure]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        errorMessage: payload,
        isLoading: false,
      };
    },
    [executorCardActions.createExecutor]: state => {
      return { ...state, createIsLoading: true };
    },
    [executorCardActions.createExecutorSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        create: payload,
        createIsLoading: false,
      };
    },
    [executorCardActions.createExecutorError]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        createErrors: payload,
        createIsLoading: false,
      };
    },
    [executorCardActions.updateExecutor]: state => {
      return { ...state, updateIsLoading: true };
    },
    [executorCardActions.updateExecutorSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        create: payload,
        updateIsLoading: false,
      };
    },
    [executorCardActions.updateExecutorError]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        updateErrors: payload,
        updateIsLoading: false,
      };
    },
    [executorCardActions.deleteExecutor]: (state, action) => {
      return {
        ...state,
      };
    },
    [executorCardActions.restoreArchiveExecutor]: (state, action) => {
      return {
        ...state,
      };
    },
  },
  initState
);
